import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { toast } from "react-toastify";
import DateTime from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import constants from "../../../Constants";

const columns = [
  {
    name: "Nº TAM",
    selector: "nuTermo",
    minWidth: "70px",
    center: true,
    sortable: true,
  },
  {
    name: "Lavratura",
    selector: "tmLavratura",
    minWidth: "250px",
    center: true,
    sortable: true,
    cell: (row) => (
      <span>
        <DateTime value={row.tmLavratura} />
      </span>
    ),
  },
  {
    name: "Situação",
    selector: "stProdutoAcaoFiscal",
    minWidth: "80px",
    center: true,
    sortable: true,
  },
];

const useTAM = (sqAcaoFiscal) => {
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    const values = {
      SqAcaoFiscal: sqAcaoFiscal,
      pageSize,
      pageNumber,
    };

    request(apiRoutes.fiscalizacao.ordemservico.listaTAM, values);
  }, [pageNumber, pageSize, request, sqAcaoFiscal]);

  useEffect(() => {
    if (!data && !errors) return;

    if (data?.result.length > 0) {
      setRows(data?.result || []);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  const listaTAM = (
    <div style={{ width: "100%" }}>
      <Row>
        <Col>
          <h5>TAM</h5>
          <DataTable
            noHeader
            keyField="nuTermo"
            columns={columns}
            data={rows}
            progressPending={isLoading}
            noDataComponent="Não existem registros."
            progressComponent={<TextSpinner />}
            defaultSortFieldId={1}
            sortIcon={<BsArrowDown />}
            pagination
            paginationServer
            sortable
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={constants.paginationComponentOptions}
            pointerOnHover
            paginationPerPage={pageSize}
          />
        </Col>
      </Row>
    </div>
  );

  return { listaTAM };
};

export default useTAM;
